import { useSelector } from 'react-redux';
import { IApplicationState } from '../../store';

// We have no routes that support an anonymous user. This is more for testing support than anything else.
const defaultUser = {
	name: 'anonymous',
	external_userid: '0',
	external_clientid: '0',
};

export const useCurrentUser = () => {
	const user = useSelector((state: IApplicationState) => state.oidc?.user);
	return user?.profile || defaultUser;
};
